import { render, staticRenderFns } from "./CAcademicYear.vue?vue&type=template&id=47c284a2"
import script from "./CAcademicYear.vue?vue&type=script&lang=js"
export * from "./CAcademicYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c284a2')) {
      api.createRecord('47c284a2', component.options)
    } else {
      api.reload('47c284a2', component.options)
    }
    module.hot.accept("./CAcademicYear.vue?vue&type=template&id=47c284a2", function () {
      api.rerender('47c284a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CAcademicYear.vue"
export default component.exports